import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { renderStartEndLocation, renderTimeDate, renderDateText, renderDurationText } from '../../../../helpers/cyoaHelper';
import Collapsible from 'react-collapsible';
import _filter from 'lodash/filter';
import { ISOCurrencyCovert } from '../../../../helpers/locationHelper';
import ResponsiveImage from '../../../shared/responsiveImage';
import { PostIntinerariesAccomodation } from '../../../../actions/itineraries';
import { pluralHelper } from '../../../../helpers/stringutils';
import { Tooltip } from 'react-tippy';
import { CYOA_NETWORK_IDS } from '../../../../config';



class ItineraryCard extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      accordionOpen:false,
      accordiontransitionTime:300,
      accommodationType: null,
      isTouched:false,
      full_accomodation_paid:false //Confirmed - full paymment with accommodation
    }
    this.toggleCollapsible = this.toggleCollapsible.bind(this);
    this.onAccommodationChange = this.onAccommodationChange.bind(this);
  }

  componentDidMount(){
    this.checkAccomodationTypes();

    this.setState({
      accommodationType: (Object.keys(this.props.data.accommodation).length > 0 && Object.keys(this.props.data.accommodation.bookings).length > 0) ? this.props.data.accommodation.bookings.type : "none",
      full_accomodation_paid: parseFloat(this.props.itineraries.total_paid) === ( parseFloat(this.props.itineraries.total) + parseFloat(this.props.itineraries.accomm_total)) ? true : false
    });

  }

  componentDidUpdate(prevProp, prevState){

    const { masterAccommodationType } = this.props;

    if(masterAccommodationType !== prevProp.masterAccommodationType){
      this.checkAccomodationTypes();
    }

  }

  checkAccomodationTypes(){

    const { masterAccommodationType, data } = this.props;
    const { isTouched } = this.state;
    const roomData = Object.keys(data.accommodation).length > 0 ? data.accommodation.rooms : [];
    const hasAccommodation = (Object.keys(data.accommodation).length > 0 && Object.keys(data.accommodation.bookings).length > 0 && data.accommodation.bookings.total !== "0.00");
    const isCyoaTours = (data.tour_id === CYOA_NETWORK_IDS["europe"].id || data.tour_id === CYOA_NETWORK_IDS["usa"].id);

    if(!isTouched && isCyoaTours && hasAccommodation){
      //SET DEFAULT IF ONLY ONLY ROOM OPTION - OTHERWISE TOGGLE MASTER
      if(roomData.length === 2) this.setState({accommodationType:masterAccommodationType});
      if(roomData.length === 1 && masterAccommodationType !== "none") this.setState({accommodationType:"default"});
      if(roomData.length === 1 && masterAccommodationType === "none") this.setState({accommodationType:"none"});
    }
    else{
      this.setState({accommodationType: (Object.keys(data.accommodation).length > 0 && Object.keys(data.accommodation.bookings).length > 0) ? data.accommodation.bookings.type : "none"});
    }
 

  }

  roomNameConvert(typeName){
    if(typeName === 'default') return 'Dorm room';
    if(typeName === 'upgrade') return 'Private room';
  }

  onAccommodationChange(e){

    this.setState({
      accommodationType:e.target.value,
      isTouched:true
    }, ()=>{

      setTimeout(()=>{ this.props.PostIntinerariesAccomodation(this.props.itineraries, true); }, 100);

    });
  }

  toggleCollapsible(){

    //Scroll into view
    ReactDOM.findDOMNode(this).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

    this.setState({accordionOpen: !this.state.accordionOpen});
  }


  renderCollapseHeader(data, alldata, index, trips, accommodationType){

    const roomData = Object.keys(data.accommodation).length > 0 ? data.accommodation.rooms : [];
    const imageLink = _filter(data.images, {'title': 'hero'})[0] !== undefined ? _filter(data.images, {'title': 'hero'})[0].url : "";

    let _description;
    const productClass = (data.type === 'product') ? 'fixed-product' : '';
    if(productClass){
       _description = `${_filter(trips, (o) => (o.tour_id !== CYOA_NETWORK_IDS["europe"].id || o.tour_id !== CYOA_NETWORK_IDS["usa"].id )).length === 0 ? "" : _filter(trips, ['ctfl_id', data.product_ctfl_id])[0].builder_description} : ${ISOCurrencyCovert(this.props.currency).props.children}${_filter(trips, ['ctfl_id', data.product_ctfl_id])[0] === undefined ? "" : _filter(trips, ['ctfl_id', data.product_ctfl_id])[0].passengers[0].price}`;
    }

    const durationText = () =>{
      return (index === 0 || index === alldata.length - 1) ? `${renderDateText(alldata, index, "DD MMMM YYYY", "start")}` : `${renderDateText(alldata, index, "DD MMMM YYYY", "start")} - ${renderDateText(alldata, index, "DD MMMM YYYY", "end")}`;
    }

    return (
      <div className={`itinerary--card ${data.type} ${productClass}`}>
        <div className="row">
          <div className="column small-12 medium-3 large-3 hide-for-small-only">
            <div className="itinerary-card-image">
              <ResponsiveImage src={imageLink} width={186} widthRetina={372} alt={data.name} quality={60} />
            </div>
          </div>
          <div className="column small-5 medium-4 large-5">
            <div className="itinerary-card-text">
              <h6 className="busabout-h6">{data.name}</h6>
              <p className="subtitle">{durationText()}</p>
              <p className={`day-text ${data.type}`}>
                <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 0C3.133 0 0 3.133 0 7s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7zm6.097 7A6.097 6.097 0 1 1 .903 7a6.097 6.097 0 1 1 12.194 0zM8.894 9.492L6.602 7.827a.34.34 0 0 1-.138-.274V3.048a.34.34 0 0 1 .338-.338h.396a.34.34 0 0 1 .338.338v4.13l1.99 1.448c.153.11.184.322.074.474l-.232.319a.341.341 0 0 1-.474.073z" fill="#F60" fillRule="nonzero"/>
                </svg>
                {renderDurationText(alldata, index, _description)}
              </p>

            </div>
          </div>


          <div className="column small-5 medium-4 large-4">
            <div className={`itinerary-accommodation ${accommodationType}`} style={{display: roomData.length > 0 ? 'block' : 'none' }}>
              <p className="bold no-margin accom-text">{ accommodationType === 'none' ? 'Accommodation not included' : 'Accommodation included' }</p>
              <p className="no-margin sub-text" style={{display: accommodationType === 'none' ? 'none' : 'block' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" className="moon-svg">
                <path d="M10.523 8.57A3.822 3.822 0 0 1 5.98 4.816c0-1.382.739-2.644 1.934-3.328.606-.343.453-1.261-.234-1.386A5.999 5.999 0 0 0 .586 6a5.999 5.999 0 0 0 10.66 3.777c.441-.543-.039-1.34-.723-1.207zm-3.937 2.68A5.249 5.249 0 0 1 1.336 6 5.249 5.249 0 0 1 7.543.836a4.573 4.573 0 0 0-2.313 3.98c0 2.872 2.618 5.028 5.434 4.489a5.242 5.242 0 0 1-4.078 1.945zm0 0"/>
              </svg>
              {alldata[index].accommodation.num_nights} {pluralHelper('night', alldata[index].accommodation.num_nights)} - <span className="capitialize">{ this.roomNameConvert(accommodationType) }</span>
              </p>
            </div>
          </div>

          <div className="column small-2 medium-4 large-3">
            <span className={`open-close-svg ${(alldata.length === index) ? 'is-last': ''}`} style={{display:this.state.accordionOpen ? 'none' : 'block'}}>
              <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.571 8.357H9.643V1.43A.43.43 0 0 0 9.214 1h-.428a.43.43 0 0 0-.429.429v6.928H1.43A.43.43 0 0 0 1 8.786v.428a.43.43 0 0 0 .429.429h6.928v6.928a.43.43 0 0 0 .429.429h.428a.43.43 0 0 0 .429-.429V9.643h6.928A.43.43 0 0 0 17 9.214v-.428a.43.43 0 0 0-.429-.429z" fill="#F60" fillRule="nonzero" stroke="#F60"/>
              </svg>
            </span>
            <span className={`open-close-svg close ${(alldata.length === index) ? 'is-last': ''}`} style={{display:this.state.accordionOpen ? 'block' : 'none'}}>
              <svg width="19" height="3" viewBox="0 0 19 3" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 1.5H18" stroke="#F60" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="square"/>
              </svg>
            </span>
          </div>
        </div>
        </div>

    )
  }


  render(){

  const { accordionOpen, accordiontransitionTime, accommodationType } = this.state;
  const { data, index, alldata, trips, itineraries:{status, total_paid} } = this.props;

  const roomData = Object.keys(data.accommodation).length > 0 ? data.accommodation.rooms : [];
  const address = renderStartEndLocation(index, alldata, 'start', true) || "";

  return (

    <Collapsible
      trigger={this.renderCollapseHeader(data, alldata, index, trips, accommodationType)}
      open={accordionOpen}
      transitionTime={accordiontransitionTime}
      handleTriggerClick={this.toggleCollapsible}
      className={index === alldata.length - 1 ? 'last' : ''}
      >

      <div className="itinerary--description">
        <div className="row">
          <div className="column small-12 medium-4 large-4">

            <div className="row">
              <div className="column small-12 medium-2 no-padding-right hide-for-small-only">
              <svg width="16" height="21" viewBox="0 0 16 21" xmlns="http://www.w3.org/2000/svg">
                <g fill="#F60" fillRule="nonzero">
                  <path d="M7.98 11.777a4.382 4.382 0 1 1 0-8.763 4.382 4.382 0 0 1 0 8.763zm0-7.64a3.259 3.259 0 1 0 0 6.517 3.259 3.259 0 0 0 0-6.517z"/>
                  <path d="M7.98 9.867a2.472 2.472 0 1 1 0-4.943 2.472 2.472 0 0 1 0 4.943zm0-3.82a1.349 1.349 0 1 0 0 2.698 1.349 1.349 0 0 0 0-2.698z"/>
                  <path d="M10.746 17.5a.561.561 0 0 1-.454-.89c.98-1.353 3.616-5.108 4.05-6.226.299-.706.466-1.46.494-2.226 0-1.999-.708-3.777-1.995-5.008A6.478 6.478 0 0 0 8.004 1.41h-.049A6.493 6.493 0 0 0 3.119 3.15C1.83 4.38 1.123 6.16 1.123 8.158c.018.639.14 1.27.363 1.87.41 1.188 3.377 5.143 4.485 6.566a.561.561 0 0 1-.885.69c-.42-.539-4.116-5.31-4.661-6.89A6.96 6.96 0 0 1 0 8.158c0-2.308.832-4.375 2.342-5.82A7.602 7.602 0 0 1 7.98.288c2.08-.12 4.12.621 5.637 2.05 1.51 1.445 2.342 3.512 2.342 5.82a7.413 7.413 0 0 1-.57 2.632c-.575 1.481-4.04 6.275-4.188 6.478a.561.561 0 0 1-.455.232zM7.98 20.937a.561.561 0 0 1-.397-.164l-1.587-1.587a.561.561 0 0 1 .794-.794l1.19 1.19 1.19-1.19a.561.561 0 0 1 .793.794l-1.586 1.587a.561.561 0 0 1-.397.164z"/>
                </g>
              </svg>
              </div>

              <div className="column small-12 medium-10 no-padding-left">
                <p className="bold margin-b-6">Trip meeting point</p>
                <p className="description no-margin orange-text bold">{ address[0] || "" }</p>
                <p className="description">{ address[1] || "" }</p>
              </div>
            </div>

          </div>

          <div className="column small-12 medium-4 large-4">

            <div className="row">
              <div className="column small-12 large-9 large-offset-1 no-padding">
                <ul>
                  <li style={{display: renderTimeDate(alldata, index, 'start') === "" ? "none" : "block" }}>
                      <p className="bold margin-b-6">{`${data.type === 'product' ? 'Trip Starts:' : 'Drop-off:' }`}</p>
                      <p className="subtext">{ renderTimeDate(alldata, index, 'start') }</p>
                  </li>
                  <li style={{display: renderTimeDate(alldata, index, 'end') === "" ? "none" : "block" }}>
                    <p className="bold margin-b-6">{`${data.type === 'product' ? 'Trip Ends:' : 'Next pick-up:' }`}</p>
                    <p className="subtext">{ renderTimeDate(alldata, index, 'end') }</p>
                  </li>
                </ul>
              </div>
            </div>

          </div>

          <div className="column small-12 medium-4 large-4 col-no-pad-left-medium" style={{display:roomData.length > 0  ? 'block' : 'none' }}>
            <div className="row">
              <div className="column small-12 medium-2 no-padding-right hide-for-small-only">
                <svg width="20" height="23" viewBox="0 0 20 23" xmlns="http://www.w3.org/2000/svg">
                  <g fill="#ff6700" fillRule="nonzero">
                    <path d="M8.386 2.63a.597.597 0 0 1-.402-1.039L9.564.155a.597.597 0 0 1 .794-.008l1.623 1.413a.597.597 0 0 1-.784.9L9.974 1.396 8.787 2.475a.594.594 0 0 1-.401.155zM19.403 22.867H.597A.597.597 0 0 1 0 22.27V9.935c0-.871.38-1.7 1.042-2.266L6.13 3.308a.597.597 0 0 1 .777.906L1.82 8.575c-.398.34-.626.837-.626 1.36v11.738h17.612V9.933a1.79 1.79 0 0 0-.623-1.358l-5.067-4.361a.597.597 0 0 1 .779-.905l5.067 4.36A2.983 2.983 0 0 1 20 9.933V22.27a.597.597 0 0 1-.597.597z"/>
                    <path d="M3.637 21.376a.597.597 0 0 1-.597-.597v-6.716a.597.597 0 0 1 1.194 0v6.716c0 .33-.267.597-.597.597zM16.363 21.376a.597.597 0 0 1-.597-.597v-4.772a.597.597 0 1 1 1.194 0v4.772c0 .33-.267.597-.597.597z"/>
                    <path d="M16.363 19.785H3.637a.597.597 0 0 1-.597-.597v-1.59c0-.33.267-.597.597-.597h12.726c.33 0 .597.267.597.597v1.59c0 .33-.267.597-.597.597zm-12.13-1.194h11.533v-.396H4.234v.396z"/>
                    <path d="M7.82 18.195H3.637a.597.597 0 0 1 0-1.194h3.058c-.353-.275-.924-.397-2.126-.397h-.932a.597.597 0 0 1 0-1.194h.932c2.546 0 3.132.615 3.785 1.92a.597.597 0 0 1-.534.865z"/>
                  </g>
                </svg>
              </div>
              <div className="column small-12 medium-10 no-padding-left">
                <p className="bold no-margin">Book {alldata[index].accommodation.num_nights} {pluralHelper('night', alldata[index].accommodation.num_nights)}:</p>
                <p className="description green-text bold">{total_paid === "0.00" ? alldata[index].accommodation.property_name : Object.keys(alldata[index].accommodation).length > 0 ? alldata[index].accommodation.bookings.hw_property_name : "" }</p>
              </div>
            </div>

          {
              roomData.map((item, i)=> {
                return (
                  <div key={i} className={`busabout-radio radio ${i === 0 ? 'first' : ''} ${status === 'confirmed' ? 'disabled' : ''}  ${data.type === 'product' ? 'disabled' : ''} `}>
                    <input
                      id={`${item.type.toLowerCase()}AccommodationCard${index}`}
                      name={`${item.type.toLowerCase()}AccommodationCard${index}`}
                      type="radio" value={item.type.toLowerCase()}
                      checked={accommodationType === `${item.type.toLowerCase()}`}
                      onChange={this.onAccommodationChange}
                      data-index={index}
                      data-price={item.quote_price}
                      data-pricepppn={item.quote_price_pp_pn}
                      data-roomtype={item.type}
                      data-roomcode={item.code}
                      data-roomtypename={item.type_name}
                      data-checked={accommodationType === `${item.type.toLowerCase()}`} />
                    <label htmlFor={`${item.type.toLowerCase()}AccommodationCard${index}`} className="radio-label">
                    
                    <span className="bold" style={{display: item.quote_price === 0 ? "none" : "line-block" }}> {ISOCurrencyCovert(alldata[index].accommodation.iso_currency)}{item.quote_price} </span>
                    <span style={{display: item.quote_price === 0 ? "none" : "line-block" }}>-</span>
                     {item.type_name} room

                    <Tooltip title={item.description}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" className={accommodationType === `${item.type.toLowerCase()}` ? 'active' : '' }>
                        <path d="M7.5 11.45a.397.397 0 0 1-.395-.4V9.692c0-.218.176-.394.395-.394.219 0 .395.176.395.394v1.36a.397.397 0 0 1-.395.398zm0 0"/>
                        <path d="M9.277 11.45H5.723a.397.397 0 0 1 0-.794h3.554a.396.396 0 0 1 0 .793zM7.5 5.79a1.283 1.283 0 1 1 0-2.566 1.283 1.283 0 0 1 0 2.565zm0-1.778A.493.493 0 0 0 7.5 5a.493.493 0 1 0 0-.988zm0 4.593a.393.393 0 0 1-.395-.394V7.184H6.078a.396.396 0 0 1-.394-.395c0-.219.18-.394.394-.394H7.5c.219 0 .395.175.395.394v1.422a.393.393 0 0 1-.395.394zm0 0"/>
                        <path d="M7.5 15C3.36 15 0 11.64 0 7.5 0 3.36 3.36 0 7.5 0 11.64 0 15 3.36 15 7.5A7.507 7.507 0 0 1 7.5 15zM7.5.79A6.71 6.71 0 0 0 .79 7.5a6.71 6.71 0 0 0 6.71 6.71 6.71 6.71 0 0 0 6.71-6.71A6.72 6.72 0 0 0 7.5.79zm0 0"/>
                      </svg>
                    </Tooltip>
                  </label>
                  </div>
                )
              })
            }


            <div className={`busabout-radio radio last ${status === 'confirmed' ? 'disabled' : ''}`} style={{display: data.type === 'product' ? 'none' : 'block'  }}>
              <input
                id={`noAccommodationCard${index}`}
                name={`noAccommodationCard${index}`}
                type="radio"
                value="none"
                checked={accommodationType === 'none'}
                onChange={this.onAccommodationChange}
                data-index={index}
                data-price={0}
                data-pricepppn={0}
                data-roomtype={"none"}
                data-roomcode={null}
                data-roomtypename={"none"}
                data-checked={accommodationType === 'none'}/>
              <label htmlFor={`noAccommodationCard${index}`} className="radio-label">  No thanks</label>
            </div>

          </div>
        </div>
      </div>

      </Collapsible>

  )


  }
}

function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    PostIntinerariesAccomodation
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ItineraryCard);



// WEBPACK FOOTER //
// ./src/components/itinerary/details/components/itinerary-card.js